import { gql } from '@apollo/client'

export const DISPLAY_SHARE_OVER_TIME = gql`
  query DisplayShareOverTime($input: DXOExecutionForZonePathInput!) {
    displayShareOverTime(input: $input) {
      date
      myBrands
      competition
      shared
    }
  }
`
